import { Flex, Text } from '@chakra-ui/react'
import { EditorPanelItem } from '@editor/interfaces/editor'
import { InspectionGroup } from '@editor/interfaces/inspectionGroup'
import { patchInspectionGroup } from '@editor/pages/projects/editor/store/inspectionGroup'
import { isInspectionGroup } from '@editor/services/InspectionGroup'
import { useAppDispatch } from '@editor/store/app'

import PopoverEditingGroup from '../PopoverEditingGroup'

interface GroupNameProps {
  group: InspectionGroup
  groups: EditorPanelItem[]
  isAllowedToModify: boolean
}

const GroupName = ({ group, groups, isAllowedToModify }: GroupNameProps) => {
  const dispatch = useAppDispatch()

  return isAllowedToModify ? (
    <PopoverEditingGroup
      group={group}
      onComplete={(name, color) => {
        const groupPanelItem = groups.find((g) => isInspectionGroup(g.item) && g.item.group_id === group.group_id)

        if (isInspectionGroup(groupPanelItem?.item)) {
          dispatch(
            patchInspectionGroup({
              ...groupPanelItem,
              name,
              color,
              item: {
                ...groupPanelItem.item,
                name,
                color,
              },
            }),
          )
        }
      }}
    />
  ) : (
    <Flex gap={2} className="popover-editing">
      <Text fontWeight="bold" className="group-name">
        {group.name}
      </Text>
    </Flex>
  )
}
export default GroupName
